export default function() {
    $(document).ready(function() {
        $('#send-contact').click(function() {
            var $form = $(this).closest('form');
            sendContact($form);
            event.preventDefault();
            return false;
        });

        labelAnimate();
    });

    function labelAnimate() {
        $('.contact-form')
            .find('input.input__field')
            .each((index, input) => {
                const $input = $(input);
                const value = input.value.trim();

                if (value !== '') {
                    $input.parent().addClass('input--filled');
                } else {
                    $input.parent().removeClass('input--filled');
                }

                $input.on('focus', () => {
                    $input.parent().addClass('input--filled');
                });

                $input.on('blur', () => {
                    if (input.value.trim() === '') {
                        $input.parent().removeClass('input--filled');
                    }
                });
            });

        //textarea
        $('.contact-form')
            .find('textarea.input__field')
            .each((index, txtArea) => {
                const $element = $(txtArea);
                const value = txtArea.value.trim();

                if (value !== '') {
                    $element.parent().addClass('input--filled');
                } else {
                    $element.parent().removeClass('input--filled');
                }

                $element.on('focus', () => {
                    $element.parent().addClass('input--filled');
                });

                $element.on('blur', () => {
                    if (txtArea.value.trim() === '') {
                        $element.parent().removeClass('input--filled');
                    }
                });
            });
    }

    function sendContact($form) {
        if (validateForm($form)) {
            var url = '/umbraco/Surface/ContactSurface/SendContactForm';
            var formData = new FormData($form[0]);

            var $btnSubmit = $('.submit-btn', $form)
            $btnSubmit.addClass('submitting');
            $('input[type=submit]', $btnSubmit).attr("disabled", true);

            $.ajax({
                type: "POST",
                url: url,
                contentType: false,
                cache: false,
                processData: false,
                data: formData, // serializes the form's elements.
                success: function(data) {

                    if (data.status === 200) {
                        $('#contact-message-response').html("The message is sent with success.");
                        $('.contact-form-wr').find("input[type=text], input[type=email], textarea").val("");
                        labelAnimate();
                        setDefaultDropdown('#drop-dd-industry');
                    } else {
                        $('#contact-message-response').html("Have an issue when sending the messsage. Please try it later.");
                    }
                    hideMessage($('#contact-message-response'));
                },
                error: function(error) {
                    //  $('.registry-form__content__form .submit-button').removeClass('btn-loading').removeAttr("disabled");
                }
            });
        }
        return false;
    }

    function setDefaultDropdown($ele) {
        var defaultValue = $('#drop-dd-industry li:first-child').data("value");
        $('.choose-value', $ele).val(defaultValue);
        $('.choose-selected', $ele).html(defaultValue);
    }

    function validateRequiredFields($form) {
        var isValid = true;
        var requiredFields = $('input.required', $form);

        for (var i = 0; i < requiredFields.length; i++) {
            var $field = $(requiredFields[i]);
            var $container = $field.closest('.mc-field-group');

            if ($field.val() == "") {
                isValid = false;
                $container.addClass('has-error');
                $('.error-message', $container).show();
            } else {
                $('.error-message', $container).hide();
                $container.removeClass('has-error');
            }
        }

        return isValid;
    }

    function validateForm($form) {
        var isValid = true;
        if (!validateRequiredFields($form)) {
            isValid = false;
        } else {
            var $email = $('input[name=Email]', $form);
            var $emailContainer = $email.closest(".mc-field-group");
            if ($email.val() != "" && !validateEmail($email.val())) {
                $(".error-message", $emailContainer).show();
                isValid = false;
            } else {
                $(".error-message", $emailContainer).hide();
            }
        }

        return isValid;
    }

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function hideMessage($ele) {
        var $btnSubmit = $('.submit-btn')
        $btnSubmit.removeClass('submitting');
        $('input[type=submit]', $btnSubmit).removeAttr("disabled");
        setTimeout(function() {
            $ele.hide();
        }, 5000);
    }
}
